import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useParams, useLocation, useNavigate } from 'react-router';

import useAuth from 'src/hooks/useAuth';

import { getSigners } from 'src/redux/slices/documentSigner';

import { useSelector } from '../../redux/store';
import { getDocument } from '../../redux/slices/document';
import LoadingScreen from '../../components/LoadingScreen';
import { GetSessionData, getSigningSession } from '../../redux/slices/signatureSession';
import { DocumentSignatureType } from '../../@types/documents/enums/documentSignatureTypes';

//------------------------------------

const EparakstsMobileCallback = () => {
  const { document } = useSelector((state) => state.document);
  const { signers } = useSelector((state) => state.documentSigner);
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('sessionId');
  const error = searchParams.get('error');
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const { user: authUser } = useAuth();
  const userEmail = authUser?.email;

  const reloadData = (id: number) => {
    getSigners(id).then();
  };

  const getSigningDocument = async (id: number) => {
    await getDocument(id);
  };

  useEffect(() => {
    if (document) {
      reloadData(document.id);
    }
  }, [document]);

  useEffect(() => {
    if (!error && document && sessionId && signers.length !== 0) {
      const userData = signers.filter((item) => item.email === userEmail);

      try {
        const getSessionData = {
          documentId: document.id,
          signatureType: DocumentSignatureType.EParaksts,
          documentName: document.name,
          documentExtension: document.extension,
          comment: userData[0].comment,
        } as GetSessionData;

        getSigningSession(sessionId, getSessionData).then();
      } catch (error: any) {
        throw error;
      } finally {
        <LoadingScreen />;

        setTimeout(() => {
          const url = location.pathname.replace('/eparaksts-mobile/callback', '');

          navigate(url);
        }, 2000);
      }
    }

    if (error && document && sessionId && signers.length !== 0) {
      let url = location.pathname.split('/eparaksts-mobile/callback')[0];
      url += `?error=${error}`;

      navigate(url);
    }
  }, [document, sessionId, signers]);

  useEffect(() => {
    let docId;

    if (typeof id === 'string') {
      docId = parseInt(id, 10);
    }

    if (docId && !Number.isNaN(docId)) {
      getSigningDocument(docId).then();
    }
  }, [id]);

  return <LoadingScreen />;
};

export default EparakstsMobileCallback;
